export const WORLDLINE_PAYMENT_TOKENIZER_SCRIPT = process.env.NEXT_PUBLIC_WORLDLINE_TOKENIZER_SCRIPT
